import React, { useEffect, useRef, useState } from 'react'
import { useAction } from '../utils/react-redux'
import classNames from 'classnames'
import SVGIcon from '../svg/SVGIcon'
import { getLocaleUnderscored } from '../i18n'
import { getApiKey, getDomain } from '../../parameters'
import {
  selectIsOutdoorDisplayed,
  selectOutdoorTargetCoordinates,
  selectOutdoorPanoramicId
} from '../../store/ui/ui.outdoor.selectors'
import { selectLocale } from '../../store/locale/locale.selectors'
import { useSelector } from 'react-redux'
import '../../../node_modules/web-api-360/dist/MappyOutdoorView.css'
import s from './Outdoor.less'
import { navigateBack } from '../../store/history/history.actions'
import useEventCallback from '../utils/useEventCallback'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'

const Outdoor = () => {
  const wrapper = useRef()
  const view = useRef()
  const [loaded, setLoaded] = useState(false)

  const isOutdoorDisplayed = useSelector(selectIsOutdoorDisplayed)
  const outdoorPanoramicId = useSelector(selectOutdoorPanoramicId)
  const outdoorTargetCoordinates = useSelector(selectOutdoorTargetCoordinates)
  const locale = useSelector(selectLocale)
  const execNavigateBack = useAction(navigateBack)

  const loadScript = () =>
    import(
      /* webpackChunkName: "outdoor" */ 'script-loader!../../../node_modules/web-api-360/dist/MappyOutdoorView.min'
    )

  /* Don’t use useEventCallback, nor useErrorBoundaryCallback, see NES-3215 */
  const debugKeyHandler = useEventCallback(event => {
    if (event.key === 'd') {
      view.current?.toggleDebug()
    }
  }, [])

  const listenKeyForDebug = () => document.body.addEventListener('keydown', debugKeyHandler)

  const stopListeningKeyForDebug = () => document.body.removeEventListener('keydown', debugKeyHandler)

  const hide = () => {
    execNavigateBack()
    setLoaded(false)
  }

  useEffect(() => {
    if (!loaded) return
    listenKeyForDebug()
    return stopListeningKeyForDebug
  }, [loaded])

  const createOutdoorView = () => {
    const { lat, lng } = outdoorTargetCoordinates
    view.current = new window.MappyOutdoor.View(wrapper.current, outdoorPanoramicId, {
      apikey: getApiKey(),
      domain: `${getDomain()}.net`,
      imgPath: `/assets/${window.__APP_VERSION__}/outdoor`,
      locale: getLocaleUnderscored(locale)
    })
    view.current.lookAt({ lat, lon: lng })
  }

  useEffect(() => {
    if (isOutdoorDisplayed) {
      loadScript()
        .then(createOutdoorView)
        .then(() => setLoaded(true))
    }
  }, [isOutdoorDisplayed])

  useEffect(() => {
    return () => hide
  }, [])

  if (!isOutdoorDisplayed) return null

  return (
    <>
      <div ref={wrapper} className={classNames(s.root, isOutdoorDisplayed && s.active)} />
      <div className={s.closeBtn} onClick={hide}>
        <SVGIcon icon={'croix-android'} />
      </div>
    </>
  )
}

// webpack:BrowserOnly
export default withEmptyFallbackErrorBoundary(Outdoor)
